<template>
  <div class="home ghome">
    <div id="nav" class="header">
      <head-top></head-top>
    </div>
    <div class="home-top">
      <div class="home-top-main">
        <div
          class="home-top-tit animated"
          :class="homeBanner ? 'bottom_1s' : ''"
        >
          让家居安装变得更便捷
        </div>
        <div
          class="home-top-desc animated"
          :class="homeBanner ? 'bottom_1s' : ''"
        >
          安装、付款、客户评价全程了解
        </div>
        <!-- <div
          class="home-goMaster animated delay-1m"
          :class="homeBanner ? 'bottom_1s' : ''"
          @click="placeOrder()"
        >
          <el-button type="primary">
            急速下单找师傅
            <i class="iconfont iconjiantou_banner"></i>
          </el-button>
        </div> -->

      </div>
    </div>
    <div class="home-service">
      <div
        class="home-service-tit serviceTit animated delay-1s1"
        :class="homeBanner ? 'originOpacity' : ''"
      >
        优质放心的家居安装服务
      </div>
      <div
        class="home-service-desc serviceDesc animated delay-1s1"
        :class="homeBanner ? 'originOpacity' : ''"
      >
        公开透明的服务流程 安全放心的资金管理
      </div>
      <div class="home-service-cont">
        <div
          class="service-li-left animated delay-1s1"
          :class="homeBanner ? 'left_8m' : ''"
        >
          <div class="service-item">
            <div
              class="service-item-icon"
              @mouseenter="lciconBool = true"
              @mouseleave="lciconBool = false"
            >
              <svg aria-hidden="true">
                <use
                  class="icon"
                  :xlink:href="
                    lciconBool
                      ? '#iconicon_home_liucheng_act1'
                      : '#iconicon_home_liucheng_nor1'
                  "
                />
              </svg>
              <!-- <i class="iconfont iconicon_home_liucheng_nor"></i> -->
            </div>
            <div class="service-item-name">流程更透明</div>
            <div class="service-item-desc">
              线上监控提货、配送、安装等节点，短信微信消息即时提醒
            </div>
          </div>
          <div class="service-item">
            <div
              class="service-item-icon"
              @mouseenter="cbiconBool = true"
              @mouseleave="cbiconBool = false"
            >
              <svg aria-hidden="true">
                <use
                  class="icon"
                  :xlink:href="
                    cbiconBool
                      ? '#iconicon_home_chengben_act1'
                      : '#iconicon_home_chengben_nor1'
                  "
                />
              </svg>
            </div>
            <div class="service-item-name">成本更低廉</div>
            <div class="service-item-desc">
              无任何附加收费，多位师傅提供报价，客户择优选择
            </div>
          </div>
        </div>
        <div
          class="service-li-right animated delay-1s"
          :class="homeBanner ? 'right_8m' : ''"
        >
          <div class="service-item">
            <div
              class="service-item-icon"
              @mouseenter="cciconBool = true"
              @mouseleave="cciconBool = false"
            >
              <svg aria-hidden="true">
                <use
                  class="icon"
                  :xlink:href="
                    cciconBool
                      ? '#iconicon_home_anquan_nor2'
                      : '#iconicon_home_anquan_nor3'
                  "
                />
              </svg>
            </div>
            <div class="service-item-name">财产更安全</div>
            <div class="service-item-desc">
              师傅实名认证，提货安装拍照确认，平台担保交易
            </div>
          </div>
          <div class="service-item">
            <div
              class="service-item-icon"
              @mouseenter="fwiconBool = true"
              @mouseleave="fwiconBool = false"
            >
              <svg aria-hidden="true">
                <use
                  class="icon"
                  :xlink:href="
                    fwiconBool
                      ? '#iconicon_home_fuwu_nor2'
                      : '#iconicon_home_fuwu_nor3'
                  "
                />
              </svg>
            </div>
            <div class="service-item-name">服务更放心</div>
            <div class="service-item-desc">
              任何争议问题都可以随时联系官方客服人员跟进解决
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-process">
      <div
        class="home-service-tit processAnim animated"
        :class="processBool ? 'bottom_1s' : ''"
      >
        完善的流程 保证服务质量
      </div>
      <div
        class="home-service-desc processAnim animated"
        :class="processBool ? 'bottom_1s' : ''"
      >
        聚师傅全程同步订单状态
      </div>
      <div
        class="home-process-hx animated delay-1m"
        :class="processBool ? 'bottom_1s' : ''"
      ></div>
      <div
        class="home-process-cont animated delay-1m"
        :class="processBool ? 'bottom_1s' : ''"
      >
        <ul>
          <li
            class="home-process-item"
            v-for="(item, index) in lcArr"
            :class="index === lcActive ? 'bgActive' : ''"
            :style="{ backgroundImage: 'url(' + item.bgSrc + ')' }"
            @mouseenter="lcMouseenter(index)"
            @mouseleave="lcMouseleave(index)"
          >
            <div class="home-process-item-main">
              <div class="home-process-icon">
                <i class="iconfont" :class="item.icon"></i>
              </div>
              <div class="home-process-tit">{{ item.text }}</div>
              <div class="home-process-yq"></div>
              <div class="home-process-main-hx"></div>
              <div class="home-process-index">{{ "0" + (index + 1) }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="home-coop animated" :class="coopBool ? 'bottom_1s' : ''">
      <div class="home-coop-main">
        <div class="home-coop-tit">
          <span>品类齐全</span>
          <span>快速匹配师傅</span>
        </div>
        <div class="home-coop-cont">
          <ul>
            <li class="home-coop-item" v-for="(item, index) in coopArr">
              <div class="home-coop-item-main">
                <div class="home-coop-icon">
                  <svg aria-hidden="true">
                    <use class="icon" :xlink:href="'#' + item.icon" />
                  </svg>
                </div>
                <div class="home-coop-goOrder">{{ item.text }}</div>
                <div class="home-coop-text">{{ item.text }}</div>
              </div>
            </li>
          </ul>
          <!-- <div class="home-coop-more">
            <span class="home-coop-more-text">查看更多品类</span>
            <i class="iconfont iconicon_kind_more"></i>
          </div>-->
        </div>
      </div>
    </div>
    <div class="home-other">
      <div
        class="home-service-tit otherTit animated"
        :class="hzgsBool ? 'bottom_1s' : ''"
      >
        他们都在使用聚师傅
      </div>
      <div
        class="home-service-desc otherDesc animated"
        :class="hzgsBool ? 'bottom_1s' : ''"
      >
        加入聚师傅 共同打造家居服务领域新规范
      </div>
      <div
        class="home-other-cont animated delay-1m"
        :class="hzgsBool ? 'bottom_1s' : ''"
      >
        <ul>
          <li class="home-other-item">
            <img src="../assets/img/hzgs1.png" alt />
          </li>
          <li class="home-other-item">
            <img src="../assets/img/hzgs2.png" alt />
          </li>
          <li class="home-other-item">
            <img src="../assets/img/hzgs3.png" alt />
          </li>
          <li class="home-other-item">
            <img src="../assets/img/hzgs4.png" alt />
          </li>
        </ul>
      </div>
    </div>
    <div class="home-join">
      <div
        class="home-service-tit joinTit animated"
        :class="joinBool ? 'bottom_1s' : ''"
      >
        加入聚师傅平台
      </div>
      <div
        class="home-service-desc joinDesc animated"
        :class="joinBool ? 'bottom_1s' : ''"
      >
        共同打造行业服务新规范
      </div>
      <div
        class="home-join-cont animated delay-1m"
        :class="joinBool ? 'bottom_1s' : ''"
      >
        <ul>
          <li
            class="home-join-item"
            v-for="(item, index) in joinArr"
            @click="goPage(item)"
          >
            <div class="home-join-item-main"></div>
            <svg aria-hidden="true">
              <use class="icon" :xlink:href="'#' + item.icon" />
            </svg>
            <span>{{ item.text }}</span>
            <i class="iconfont joinJt iconjiantou_big"></i>
          </li>
        </ul>
      </div>
    </div>

    <!-- <el-dialog
      title="平台邀请公告"
      :visible.sync="$store.state.announcement"
      width="30%"
      class="announcement"
    >
      <div style="text-indent: 28px;line-height: 23px;">
        聚师傅家居服务平台将于2020.04.20日正式启动全国范围内各地区家具安装服务商入驻事宜，为期60天，期间平台发布订单功能将暂时关闭，该批次服务商将采用“市级”服务商和“县级”服务商模式入驻，遵循一个地区一个服务商原则，对于此轮首批入驻服务商平台将予免除一切费用，欢迎国内各地服务商实地或来电洽谈。热线电话：028-64967606；19141061652（工作时间9:00—18:00）.
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$store.state.announcement = false"
          >确 定</el-button
        >
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import headTop from "./../components/headTop";
export default {
  components: {
    headTop
  },
  name: "home",
  data() {
    return {
      homeBanner: false,
      lciconBool: false,
      cbiconBool: false,
      cciconBool: false,
      fwiconBool: false,
      processBool: false,
      coopBool: false,
      hzgsBool: false,
      joinBool: false,
      announcement: true,
      lcArr: [
        {
          icon: "icontijiaodingdan",
          text: "提交订单",
          bgSrc: require("../assets/img/lcbz1.png")
        },
        {
          icon: "iconicon_",
          text: "师傅接单",
          bgSrc: require("../assets/img/lcbz2.png")
        },
        {
          icon: "iconicon_1",
          text: "上门安装",
          bgSrc: require("../assets/img/lcbz3.png")
        },
        {
          icon: "icontijiaodingdanbeifen1",
          text: "客户评分",
          bgSrc: require("../assets/img/lcbz4.png")
        },
        {
          icon: "iconicon_2",
          text: "获得报酬",
          bgSrc: require("../assets/img/lcbz5.png")
        }
      ],
      lcActive: 2,
      coopArr: [
        {
          icon: "iconicon_kind_11",
          text: "家居"
        },
        {
          icon: "iconicon_kind_10",
          text: "卫浴"
        },
        {
          icon: "iconicon_kind_12",
          text: "灯具"
        },
        {
          icon: "iconicon_kind_14",
          text: "锁具"
        },
        {
          icon: "iconicon_kind_13",
          text: "门窗"
        },
        {
          icon: "iconicon_kind_17",
          text: "衣架"
        },
        {
          icon: "iconicon_kind_16",
          text: "吊顶"
        },
        {
          icon: "iconicon_kind_15",
          text: "家电"
        },
        {
          icon: "iconicon_kind_19",
          text: "地板"
        },
        {
          icon: "iconicon_kind_18",
          text: "净水器"
        }
      ],
      joinArr: [
        {
          icon: "iconicon_home_hongyingchang1",
          text: "加入服务商团队"
        },
        {
          icon: "iconicon_home_shifu1",
          text: "加入师傅团队"
        }
      ]
    };
  },
  mounted() {
    //页面加载完成
    this.initComplete();
  },
  methods: {
    // 页面开发
    pageDevelopment() {
      this.$message("功能即将上线");
    },
    //页面加载完成
    initComplete() {
      let timer = 0;
      this.$nextTick(() => {
        this.homeBanner = true;
        this.getScrollInitTop();
      });
      window.addEventListener("scroll", this.handleScroll);
    },
    //流程--背景图变化--鼠标移入
    lcMouseenter(ind) {
      this.lcActive = ind;
    },
    //流程--背景图变化--鼠标移出
    lcMouseleave(ind) {
      this.lcActive = 2;
    },
    // 快速下单
    placeOrder() {
      this.$router.push({ path: "/placeorder/stepone" });
    },
    //获取一开始滚动条的位置
    getScrollInitTop() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log(top);
      top = parseInt(top);
      if (top < 230) {
        return;
      }
      if (top < 700) {
        this.processBool = true;
        return;
      }
      if (top < 1400) {
        this.processBool = true;
        this.coopBool = true;
        return;
      }
      if (top < 1800) {
        this.processBool = true;
        this.coopBool = true;
        this.hzgsBool = true;
        return;
      }
      this.processBool = true;
      this.coopBool = true;
      this.hzgsBool = true;
      this.joinBool = true;
    },
    //页面滚动
    handleScroll() {
      let top =
        pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      top = parseInt(top);
      // console.log(top);
      if (top > 240 && top < 700) {
        this.processBool = true;
      } else if (top > 700 && top < 1400) {
        this.coopBool = true;
      } else if (top > 1400 && top < 1800) {
        this.hzgsBool = true;
      } else if (top > 1800) {
        this.joinBool = true;
      }
    },
    // 页面跳转
    goPage(item) {
      if (item.text == "加入服务商团队") {
        this.$router.push({ path: "/service_ruzhu" });
      }
      if (item.text == "加入师傅团队") {
        this.$router.push({ path: "/ruzhu" });
      }
    }
  }
};
</script>
<style lang="scss">
@import "./_home.scss";
</style>

<style lang="scss" scoped>
.announcement /deep/ .el-button--primary {
  background: #3455d3;
  color: #fff;
  border-color: #3455d3;
  &:hover {
    background: #2c4abb;
    border-color: #2c4abb;
  }
}
.home /deep/ .el-dialog__body {
  padding: 10px 20px;
}
.home-goMaster {
  &:hover {
    background: #fff;
    &/deep/button {
      color: #3455d3;
    }
  }
}
</style>
